import React, { useState } from "react";
import useBasketManager from "../SaleMovie/CinemaHall/hooks/useBasketManager";
import "./style/basketTableStyle.scss";
import "./style/style.scss";
import { useTranslation } from "react-i18next";

interface IProps {
  handlePromotion: (promotionCode: string) => void;
  promoMessage: string;
}

const BasketCodePromotion: React.FC<IProps> = ({ handlePromotion, promoMessage }: IProps) => {
  const { t } = useTranslation();
  const [input, setInput] = useState("");

  const handleChange = (event: any) => {
    setInput(event.target.value);
  };

  // const { promoMessage } = useBasketManager();

  return (
    <React.Fragment>
      <div className="basket-code-promotion flex-column">
        {promoMessage && (
          <React.Fragment>
            {promoMessage === t("podany_kod_jest_poprawny") ? (
              <b className=" alert alert-green">{promoMessage}</b>
            ) : (
              <b className=" alert alert-red">{promoMessage}</b>
            )}
          </React.Fragment>
        )}

        <div className="flex-between-center">
          <input placeholder={t("kod_rabatowy")} onChange={handleChange} />
          {input === "" ? (
            <button className="button medium padding-medium button-fill-disable">{t("dodaj")}</button>
          ) : (
            <button onClick={() => handlePromotion(input)} className="button medium padding-medium button-fill-main">
              {t("dodaj")}
            </button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasketCodePromotion;
